import { MintingWindowState, MintWindowParams } from "../types/mint";
import { Box, Typography } from "@mui/material";
import { formatDate } from "../lib/date";
import React from "react";

interface Props {
  mintWindowParams: MintWindowParams;
}

const MintTitle = ({ mintWindowParams }: Props) => {
  if (mintWindowParams.state !== MintingWindowState.BEFORE_MINT) {
    return null;
  }

  return (
    <Box mt={10} mb={3} sx={{ fontSize: "28px" }}>
      <Typography
        sx={{
          display: "inline",
          fontWeight: 800,
          fontSize: "inherit",
        }}
      >
        {mintWindowParams.nextMint}
      </Typography>{" "}
      opens{" "}
      <Typography
        sx={{
          display: "inline",
          fontWeight: 800,
          fontSize: "inherit",
          background:
            "-webkit-linear-gradient(70deg, #73358F 0%, #BC3852 25%, #ED5736 75%, #E6824B 100%)",
          "-webkit-background-clip": "text",
          "-webkit-text-fill-color": "transparent",
          color: "#fff",
        }}
      >
        {formatDate(mintWindowParams.nextMintOpensAt)}
      </Typography>
    </Box>
  );
};

export default MintTitle;
